<template>
  <div class="py-4 container-fluid">
    <div class="row mb-2">
      <form role="form" @submit.prevent="handleSearch">
        <div class="row">
          <!-- Start Date -->
          <div class="col-lg-3 col-md-3 col-sm-6 col-6">
            <label for="startDate">Start date</label>
            <VueDatePicker v-model="startDate" :enableTimePicker="false" />
          </div>

          <!-- End Date -->
          <div class="col-lg-3 col-md-3 col-sm-6 col-6">
            <label for="endDate">End date</label>
            <VueDatePicker v-model="endDate" :enableTimePicker="false" />
          </div>

          <!-- Agent -->
          <div class="col-lg-2 col-md-2 col-sm-6 col-6">
            <label for="agent">Agent</label>
            <select id="agent" v-model="agent" class="form-control">
              <option value="">-- เลือก Agent --</option>
              <option v-for="a in agentList" :key="a.id" :value="a.id">
                {{ a.code }}
              </option>
            </select>
          </div>

          <!-- Username -->
          <div class="col-lg-2 col-md-2 col-sm-6 col-6">
            <label for="username">Username</label>
            <input
              id="username"
              v-model="username"
              type="text"
              class="form-control"
              placeholder="กรอกชื่อผู้เล่น"
            />
          </div>

          <!-- Transaction ID -->
          <div class="col-lg-2 col-md-2 col-sm-6 col-6">
            <label for="transaction_id">Transaction ID</label>
            <input
              id="transaction_id"
              v-model="transaction_id"
              type="text"
              class="form-control"
              placeholder="กรอกชื่อรายการ"
            />
          </div>
        </div>

        <div class="row justify-content-center mt-4">
          <div class="col-6 col-sm-4 col-lg-2 mb-4">
            <argon-button
              fullWidth
              color="success"
              variant="gradient"
              type="submit"
              :disabled="loading"
            >
              <template v-if="loading">กำลังโหลด...</template>
              <template v-else>ค้นหา</template>
            </argon-button>
          </div>
          <div class="col-6 col-sm-4 col-lg-2 mb-4">
            <argon-button
              fullWidth
              color="danger"
              variant="gradient"
              @click="resetData"
              :disabled="loading"
            >
              <template v-if="loading">กำลังโหลด...</template>
              <template v-else>Reset</template>
            </argon-button>
          </div>
        </div>
      </form>
    </div>

    <!-- Currency Tabs -->
    <div
      class="d-flex flex-wrap justify-content-center align-items-center gap-3 mb-4"
    >
      <div class="currency-tabs">
        <button
          v-for="c in currencyList"
          :key="c"
          type="button"
          class="currency-tab"
          :class="{ active: currency === c }"
          @click="selectCurrency(c)"
        >
          {{ c }}
        </button>
      </div>

      <argon-button
        color="success"
        variant="gradient"
        size="sm"
        class="mb-0 export-btn"
        @click="exportExcel"
      >
        ⬇ Export Excel
      </argon-button>
    </div>

    <!-- Statistics Cards -->
    <div class="row">
      <div class="col-lg-12">
        <!-- Desktop version -->
        <div class="row d-none d-sm-flex">
          <div
            v-for="(stat, index) in statistics"
            :key="'desktop-' + index"
            class="col-xl-3 col-md-3 col-sm-6 mb-4 font-desktop"
          >
            <MiniStatisticsCard
              :title="stat.title"
              :value="{ text: stat.value, color: 'text-dark' }"
              :description="stat.description"
              :icon="stat.icon"
            />
          </div>
        </div>

        <!-- Mobile version -->
        <div class="d-block d-sm-none">
          <div class="row">
            <div
              v-for="(stat, index) in statistics.slice(0, 4)"
              :key="'mobile-row1-' + index"
              class="col-6 mb-4 font-mobile"
            >
              <MiniStatisticsCard
                :title="stat.title"
                :value="{ text: stat.value, color: 'text-dark' }"
                :description="stat.description"
                :icon="stat.icon"
              />
            </div>
          </div>
          <div class="row">
            <div
              v-for="(stat, index) in statistics.slice(4, 8)"
              :key="'mobile-row2-' + index"
              class="col-6 mb-4 font-mobile"
            >
              <MiniStatisticsCard
                :title="stat.title"
                :value="{ text: stat.value, color: 'text-dark' }"
                :description="stat.description"
                :icon="stat.icon"
              />
            </div>
          </div>
        </div>

        <div class="row mb-2">
          <div style="text-align-last: center; border: solid; padding: 10px">
            <strong>Top Player</strong><br />
            <strong>Username: </strong>
            <span style="font-size: 0.9em">{{
              top_player.username ?? "ว่าง"
            }}</span
            ><br />
            <strong>Bet: </strong>
            <span style="font-size: 0.9em"> {{
              top_player.bet_amount ?? "ว่าง"
            }}</span
            ><br />
            <strong>Reward: </strong>
            <span style="font-size: 0.9em"> {{
              top_player.win_loss ?? "ว่าง"
            }}</span
            ><br />
            <strong>Game: </strong>
            <span style="font-size: 0.9em"
              > {{ top_player.game_code ?? "ว่าง" }}
              {{ top_player.game ?? "ว่าง" }}</span
            ><br />
            <strong>Agent: </strong>
            <span style="font-size: 0.9em"> {{
              top_player.agent_id ?? "ว่าง"
            }}</span
            ><br />
            <strong>Transaction ID: </strong>
            <span style="font-size: 0.9em"> {{
              top_player.transaction_id ?? "ว่าง"
            }}</span>
          </div>
        </div>
        

        <!-- Agent Table -->
<!-- Agent Table -->
<div class="col-md-12 mt-4">
  <h5 class="mb-2 text-center fw-bold">📊 รายงานแยกตาม Agent</h5>

  <div class="table-responsive">
    <table
      class="table table-striped table-flush align-items-center text-dark mb-0"
      style="text-align-last: center"
    >
      <thead>
        <tr>
          <th @click="sortAgentBy('agent_code')">
  Agent
  <span v-if="agentSortKey === 'agent_code'">
    {{ agentSortDirection === "asc" ? "🔼" : "🔽" }}
  </span>
</th>

<th @click="sortAgentBy('bet_amount')">
  Total Bet
  <span v-if="agentSortKey === 'bet_amount'">
    {{ agentSortDirection === "asc" ? "🔼" : "🔽" }}
  </span>
</th>

<th @click="sortAgentBy('win_loss')">
  Profit
  <span v-if="agentSortKey === 'win_loss'">
    {{ agentSortDirection === "asc" ? "🔼" : "🔽" }}
  </span>
</th>

<th @click="sortAgentBy('highest_reward')">
  Highest Reward
</th>

<th @click="sortAgentBy('player_online')">
  Player Online
</th>

<th @click="sortAgentBy('transaction')">
  Transaction
</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="loading">
          <td colspan="6">🔄 กำลังโหลด...</td>
        </tr>

        <tr v-else-if="agentStats.length === 0">
          <td colspan="6">ไม่มีข้อมูล</td>
        </tr>

        <tr v-else v-for="a in sortedAgentStats" :key="a.agent_id">
          <td>{{ a.agent_code }}</td>
          <td class="text-end">{{ (a.bet_amount ?? 0).toFixed(2) }}</td>
          <td class="text-end">{{ Number(-a.win_loss || 0).toFixed(2) }}</td>
          <td class="text-end">{{ (a.highest_reward ?? 0).toFixed(2) }}</td>
          <td class="text-end">{{ a.player_online ?? 0 }}</td>
          <td class="text-end">{{ a.transaction ?? 0 }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

        <!-- Table -->
<!-- Game Table -->
<div class="col-md-12 mt-4">
  <h5 class="mb-2 text-center fw-bold">📊 รายงานแยกตาม Game</h5>

  <div class="table-responsive">
            <table
              class="table table-striped table-flush align-items-center text-dark mb-0"
              style="text-align-last: center"
            >
              <thead>
                <tr>
                  <th @click="sortBy('code')">
                    Code
                    <span v-if="sortKey === 'code'">{{
                      sortDirection === "asc" ? "🔼" : "🔽"
                    }}</span>
                  </th>
                  <th @click="sortBy('name')">
                    Game
                    <span v-if="sortKey === 'name'">{{
                      sortDirection === "asc" ? "🔼" : "🔽"
                    }}</span>
                  </th>
                  <th @click="sortBy('bet_amount')">
                    Total bet
                    <span v-if="sortKey === 'bet_amount'">{{
                      sortDirection === "asc" ? "🔼" : "🔽"
                    }}</span>
                  </th>
                  <th @click="sortBy('win_loss')">
                    Profit
                    <span v-if="sortKey === 'win_loss'">{{
                      sortDirection === "asc" ? "🔼" : "🔽"
                    }}</span>
                  </th>
                  <th @click="sortBy('highest_reward')">
                    Highest reward
                    <span v-if="sortKey === 'highest_reward'">{{
                      sortDirection === "asc" ? "🔼" : "🔽"
                    }}</span>
                  </th>
                  <th @click="sortBy('player_online')">
                    Player Online
                    <span v-if="sortKey === 'player_online'">{{
                      sortDirection === "asc" ? "🔼" : "🔽"
                    }}</span>
                  </th>
                  <th @click="sortBy('transaction')">
                    All transaction
                    <span v-if="sortKey === 'transaction'">{{
                      sortDirection === "asc" ? "🔼" : "🔽"
                    }}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loading">
                  <td colspan="10" class="text-center py-4">
                    🔄 กำลังโหลดข้อมูล...
                  </td>
                </tr>
                <tr v-else v-for="game in sortedGames" :key="game.code">
                  <td>{{ game.code }}</td>
                  <td>{{ game.name }}</td>
                  <td class="text-end">{{ (game.bet_amount ?? 0).toFixed(2) }}</td>
                  <td class="text-end">{{ Number(-game.win_loss || 0).toFixed(2) }}</td>
                  <td class="text-end">{{ (game.highest_reward ?? 0).toFixed(2) }}</td>
                  <td class="text-end">{{ game.player_online ?? 0 }}</td>
                  <td class="text-end">{{ game.transaction ?? 0 }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import axios from "axios";
import moment from "moment";
import VueDatePicker from "@vuepic/vue-datepicker";
import "flatpickr/dist/flatpickr.css";
import "@vuepic/vue-datepicker/dist/main.css";

import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { HIDDEN_GAME_CODES } from "@/constants/hiddenGames";
import ExcelJS from "exceljs";

const startDate = ref(moment().format("YYYY-MM-DD"));
const endDate = ref(moment().format("YYYY-MM-DD"));
const loading = ref(false);

const agent = ref("");
const username = ref("");
const transaction_id = ref("");
const currency = ref("ALL");
const currencyList = ref(["ALL"]);
const rawData = ref(null); // เก็บ response ดิบไว้ filter ตาม currency โดยไม่ยิง API ใหม่

const top_player = ref({}); // ใช้ ref ให้ reactive และเป็น object เริ่มต้น
const allTxn = ref(0);
const allBet = ref(0);
const allWinLoss = ref(0);
const highestReward = ref(0);
const maxBet = ref(0);
const maxBuyFeature = ref(0);
const buyFeature = ref(0);
const numOfBuyFeature = ref(0);
const playerOnline = ref(0);

const agentList = ref([]);
const sortKey = ref("");
const sortDirection = ref("asc");

const agentStats = ref([]);
const agentSortKey = ref("");
const agentSortDirection = ref("asc");
// รายชื่อเกม (master list) — ดึงจาก endpoint gameconfig แบบ dynamic
// เพิ่มเกมใน DB แล้วจะโผล่เองอัตโนมัติ ไม่ต้องแก้ไฟล์นี้
const gameConfigList = ref([]);
const games = ref([]);

// computed: statistics, sortedGames
const statistics = computed(() => {
  const percentProfit =
    allBet.value > 0
      ? ((-allWinLoss.value / allBet.value) * 100).toFixed(2)
      : 0;

  return [
    {
      title: "ยอดได้เสียสมาชิก",
      value: `${(-allWinLoss.value).toFixed(2)}  (${percentProfit}%)`,
      description: updatedAt.value,
      icon: {
        component: "ni ni-money-coins",
        background: "bg-gradient-primary",
        shape: "rounded-circle",
      },
    },
    {
      title: "ยอดเดิมพันที่ใช้ได้",
      value: allBet.value.toFixed(2),
      description: updatedAt.value,
      icon: {
        component: "ni ni-money-coins",
        background: "bg-gradient-danger",
        shape: "rounded-circle",
      },
    },
    {
      title: "เดิมพันสูงสุด",
      value: maxBet.value.toFixed(2),
      description: updatedAt.value,
      icon: {
        component: "ni ni-money-coins",
        background: "bg-gradient-warning",
        shape: "rounded-circle",
      },
    },
    {
      title: "ซื้อฟีเจอร์สูงสุด",
      value: maxBuyFeature.value.toFixed(2),
      description: updatedAt.value,
      icon: {
        component: "ni ni-cart",
        background: "bg-gradient-danger",
        shape: "rounded-circle",
      },
    },
    {
      title: "ยอดซื้อฟีเจอร์ทั้งหมด",
      value: buyFeature.value.toFixed(2),
      description: updatedAt.value,
      icon: {
        component: "ni ni-cart",
        background: "bg-gradient-success",
        shape: "rounded-circle",
      },
    },
    {
      title: "จำนวนครั้งซื้อฟีเจอร์",
      value: numOfBuyFeature.value,
      description: updatedAt.value,
      icon: {
        component: "ni ni-cart",
        background: "bg-gradient-primary",
        shape: "rounded-circle",
      },
    },
    {
      title: "ผู้เล่นออนไลน์",
      value: playerOnline.value,
      description: updatedAt.value,
      icon: {
        component: "ni ni-world",
        background: "bg-gradient-danger",
        shape: "rounded-circle",
      },
    },
    {
      title: "ธุรกรรมทั้งหมด",
      value: allTxn.value,
      description: updatedAt.value,
      icon: {
        component: "ni ni-paper-diploma",
        background: "bg-gradient-success",
        shape: "rounded-circle",
      },
    },
  ];
});


const sortedGames = computed(() => {
  if (!sortKey.value) return games.value;

  return [...games.value].sort((a, b) => {
    const valA = a[sortKey.value] ?? 0;
    const valB = b[sortKey.value] ?? 0;
    if (sortDirection.value === "asc") {
      return valA > valB ? 1 : valA < valB ? -1 : 0;
    } else {
      return valA < valB ? 1 : valA > valB ? -1 : 0;
    }
  });
});

const sortedAgentStats = computed(() => {
  if (!agentSortKey.value) return agentStats.value;

  return [...agentStats.value].sort((a, b) => {
    const valA = a[agentSortKey.value] ?? 0;
    const valB = b[agentSortKey.value] ?? 0;

    if (agentSortDirection.value === "asc") {
      return valA > valB ? 1 : valA < valB ? -1 : 0;
    } else {
      return valA < valB ? 1 : valA > valB ? -1 : 0;
    }
  });
});
const updatedAt = ref("");

// lifecycle
let intervalId = null;

onMounted(async () => {
  await fetchGameConfig(); // โหลด master list ของเกมก่อน
  fetchData();
  intervalId = setInterval(fetchData, 5 * 60 * 1000);
});
onUnmounted(() => {
  if (intervalId) clearInterval(intervalId);
});

// methods / functions

function sortBy(key) {
  if (sortKey.value === key) {
    sortDirection.value = sortDirection.value === "asc" ? "desc" : "asc";
  } else {
    sortKey.value = key;
    sortDirection.value = "asc";
  }
}

function calculateSum(arr, prop) {
  return arr.reduce((acc, obj) => acc + Number(obj[prop] ?? 0), 0);
}

function resetData() {
  startDate.value = moment().format("YYYY-MM-DD");
  endDate.value = moment().format("YYYY-MM-DD");
  agent.value = "";
  username.value = "";
  transaction_id.value = "";
  currency.value = "ALL";

  fetchData();
}

function handleSearch() {
  // รีเซตการ sort
  agentSortKey.value = "";
agentSortDirection.value = "asc";
  sortKey.value = "";
  sortDirection.value = "asc";
  fetchData();
}

function sortAgentBy(key) {
  if (agentSortKey.value === key) {
    agentSortDirection.value =
      agentSortDirection.value === "asc" ? "desc" : "asc";
  } else {
    agentSortKey.value = key;
    agentSortDirection.value = "asc";
  }
}

const API_BASE = "https://dashboard-api.linkstudio.io/api/v1/game/control";

// โหลดรายชื่อเกมทั้งหมดจาก DB (endpoint gameconfig) → ใช้เป็น master list
async function fetchGameConfig() {
  try {
    const res = await axios.post(`${API_BASE}/gameconfig`, {});
    const list = res.data?.data?.list ?? [];
    gameConfigList.value = list
      // เอาเฉพาะเกมที่ผูก schema จริง + ตัดเกมที่ซ่อนไว้ (HIDDEN_GAME_CODES)
      .filter((g) => g.schema_name && !HIDDEN_GAME_CODES.includes(g.code))
      .map((g) => ({ code: g.code, name: g.name }));
  } catch (err) {
    console.error("โหลด gameconfig ไม่สำเร็จ", err);
  }
}

async function fetchData() {
  loading.value = true;

  const sd = moment(startDate.value).format("YYYY-MM-DD");
  const ed = moment(endDate.value).format("YYYY-MM-DD");

  try {
    // filter เป็น query param บน endpoint เดียว
    const params = {};
    if (agent.value.trim()) params.agent = agent.value.trim();
    if (username.value.trim()) params.username = username.value.trim();
    if (transaction_id.value.trim()) {
      params.transaction_id = transaction_id.value.trim();
    }

    const res = await axios.get(
      `${API_BASE}/dashboard/daily-range/${sd}/${ed}`,
      { params }
    );

    // เก็บข้อมูลดิบ (ครบทุก currency) แล้วค่อย filter โชว์
    rawData.value = res.data.data;
    applyData();
    updatedAt.value = moment().format("YYYY-MM-DD HH:mm:ss");
  } catch (err) {
    console.error(err);
    window.alert("ไม่สามารถดึงข้อมูลได้");
  } finally {
    loading.value = false;
  }
}

// bind ข้อมูลตาม currency ที่เลือก จาก rawData (ไม่ยิง API)
function applyData() {
  if (!rawData.value) return;

  const n = normalizeResponseV2(rawData.value);

  agentList.value = n.agents;
  top_player.value = n.topPlayerDaily || {};

  // ----- summary -----
  const o = n.overallDaily;
  allBet.value = o.bet_amount;
  allWinLoss.value = o.win_loss;
  allTxn.value = o.transaction;
  playerOnline.value = o.player_online;
  buyFeature.value = o.buy_feature_amount;
  numOfBuyFeature.value = o.is_feature_buy;
  maxBet.value = o.bet_amount_highest;
  maxBuyFeature.value = o.feature_buy_highest;
  highestReward.value = o.highest_reward;

  // ----- game table -----
  // ยึดจาก master list (gameConfigList) → โชว์ทุกเกมเสมอ, เกมที่ไม่มีข้อมูลเติม 0 (template ใช้ ?? 0)
  const map = new Map(n.gameDaily.map((g) => [g.game_code, g]));
  games.value = gameConfigList.value.map((g) => ({
    ...g,
    ...(map.get(g.code) || {}),
  }));

  // ----- agent table -----
  agentStats.value = n.byAgent || [];
}

// สลับ currency → filter จากข้อมูลเดิม ไม่ยิง API ใหม่
function selectCurrency(c) {
  currency.value = c;
  applyData();
}

// export การ์ดสรุปเป็นไฟล์ Excel ที่จัดรูปแบบสวยงาม (ตาม currency ที่เลือกอยู่)
async function exportExcel() {
  const DARK = "FF344767"; // น้ำเงินเข้ม
  const GREEN = "FF2DCE89"; // เขียว argon
  const ZEBRA = "FFF3F5F7"; // เทาอ่อนสลับแถว
  const thin = {
    top: { style: "thin", color: { argb: "FFD9DEE3" } },
    left: { style: "thin", color: { argb: "FFD9DEE3" } },
    bottom: { style: "thin", color: { argb: "FFD9DEE3" } },
    right: { style: "thin", color: { argb: "FFD9DEE3" } },
  };

  // format วันที่ให้เป็น YYYY-MM-DD เสมอ (VueDatePicker อาจให้ค่าเป็น Date object)
  const sd = moment(startDate.value).format("YYYY-MM-DD");
  const ed = moment(endDate.value).format("YYYY-MM-DD");

  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("สรุป", {
    views: [{ state: "frozen", ySplit: 6 }],
  });
  ws.columns = [{ width: 26 }, { width: 26 }];

  // ---- Title (merge A1:B1) ----
  ws.mergeCells("A1:B1");
  const title = ws.getCell("A1");
  title.value = "สรุป Dashboard";
  title.font = { bold: true, size: 16, color: { argb: "FFFFFFFF" } };
  title.alignment = { horizontal: "center", vertical: "middle" };
  title.fill = { type: "pattern", pattern: "solid", fgColor: { argb: DARK } };
  ws.getRow(1).height = 28;

  // ---- Context ----
  const ctx = [
    ["สกุลเงิน", currency.value],
    ["ช่วงวันที่", `${sd} ถึง ${ed}`],
    ["อัปเดตล่าสุด", updatedAt.value || "-"],
  ];
  ctx.forEach((r, i) => {
    const row = ws.getRow(2 + i);
    row.getCell(1).value = r[0];
    row.getCell(1).font = { bold: true, color: { argb: DARK } };
    row.getCell(2).value = r[1];
  });

  // ---- Header (row 6) ----
  const header = ws.getRow(6);
  header.values = ["หัวข้อ", "ค่า"];
  header.height = 20;
  header.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: GREEN } };
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.border = thin;
  });

  // ---- Data ----
  statistics.value.forEach((s, i) => {
    const row = ws.getRow(7 + i);
    row.getCell(1).value = s.title;
    row.getCell(2).value = s.value;
    row.getCell(1).alignment = { horizontal: "left", vertical: "middle" };
    row.getCell(2).alignment = { horizontal: "right", vertical: "middle" };
    [1, 2].forEach((c) => {
      const cell = row.getCell(c);
      cell.border = thin;
      if (i % 2 === 1) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: ZEBRA },
        };
      }
    });
  });

  // ---- helper: sheet ตารางรายงาน (title + header + data) ----
  function addReportSheet(name, headers, colDefs, rows) {
    const sheet = wb.addWorksheet(name, {
      views: [{ state: "frozen", ySplit: 2 }],
    });
    sheet.columns = colDefs.map((c) => ({ width: c.width }));

    // title (merge ทั้งแถว)
    sheet.mergeCells(1, 1, 1, headers.length);
    const t = sheet.getCell("A1");
    t.value = name;
    t.font = { bold: true, size: 14, color: { argb: "FFFFFFFF" } };
    t.alignment = { horizontal: "center", vertical: "middle" };
    t.fill = { type: "pattern", pattern: "solid", fgColor: { argb: DARK } };
    sheet.getRow(1).height = 24;

    // header
    const hr = sheet.getRow(2);
    hr.values = headers;
    hr.height = 20;
    hr.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: GREEN } };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = thin;
    });

    // data
    rows.forEach((r, ri) => {
      const row = sheet.getRow(3 + ri);
      r.forEach((val, ci) => {
        const cell = row.getCell(ci + 1);
        cell.value = val;
        cell.alignment = {
          horizontal: colDefs[ci].align || "left",
          vertical: "middle",
        };
        if (colDefs[ci].numFmt) cell.numFmt = colDefs[ci].numFmt;
        cell.border = thin;
        if (ri % 2 === 1) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: ZEBRA },
          };
        }
      });
    });
  }

  const MONEY = "#,##0.00";
  const INT = "#,##0";
  const moneyCol = (width) => ({ width, align: "right", numFmt: MONEY });
  const intCol = (width) => ({ width, align: "right", numFmt: INT });

  // ---- Sheet 2: รายงานแยกตาม Agent ----
  addReportSheet(
    "รายงานแยกตาม Agent",
    ["Agent", "Total Bet", "Profit", "Highest Reward", "Player Online", "Transaction"],
    [
      { width: 20, align: "left" },
      moneyCol(16),
      moneyCol(16),
      moneyCol(16),
      intCol(14),
      intCol(14),
    ],
    sortedAgentStats.value.map((a) => [
      a.agent_code,
      Number((a.bet_amount ?? 0).toFixed(2)),
      Number((-a.win_loss || 0).toFixed(2)),
      Number((a.highest_reward ?? 0).toFixed(2)),
      a.player_online ?? 0,
      a.transaction ?? 0,
    ])
  );

  // ---- Sheet 3: รายงานแยกตาม Game ----
  addReportSheet(
    "รายงานแยกตาม Game",
    [
      "Code",
      "Game",
      "Total Bet",
      "Profit",
      "Highest Reward",
      "Player Online",
      "All Transaction",
    ],
    [
      { width: 10, align: "left" },
      { width: 26, align: "left" },
      moneyCol(16),
      moneyCol(16),
      moneyCol(16),
      intCol(14),
      intCol(16),
    ],
    sortedGames.value.map((g) => [
      g.code,
      g.name,
      Number((g.bet_amount ?? 0).toFixed(2)),
      Number((-g.win_loss || 0).toFixed(2)),
      Number((g.highest_reward ?? 0).toFixed(2)),
      g.player_online ?? 0,
      g.transaction ?? 0,
    ])
  );

  // ---- Download ----
  const buf = await wb.xlsx.writeBuffer();
  const blob = new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `dashboard_${currency.value}_${sd}_${ed}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}

function normalizeTopPlayer(tp) {
  if (!tp) return {};

  return {
    transaction_id: tp.transaction_id ?? "",
    username: tp.username ?? "",
    game_code: tp.game_code ?? "",
    game: tp.game ?? "",
    bet_amount: tp.bet_amount ?? 0,
    win_loss: tp.win_loss ?? 0,

    // ⭐ แก้ปัญหาหลัก
    agent_id:
      tp.agent_id ??
      tp.agent ??
      tp.agent_code ??
      "",
  };
}

// เลือก entry ตาม currency ที่เลือกไว้ (fallback: ALL → ตัวแรก)
function pickByCurrency(arr = [], cur) {
  if (!Array.isArray(arr)) return null;
  return (
    arr.find((x) => x.currency === cur) ||
    arr.find((x) => x.currency === "ALL") ||
    arr[0] ||
    null
  );
}

function normalizeResponseV2(respData) {
  const cur = currency.value || "ALL";

  // อัปเดตรายการ currency สำหรับ dropdown จาก response
  if (Array.isArray(respData.overallDaily)) {
    const curs = respData.overallDaily
      .map((o) => o.currency)
      .filter(Boolean);
    if (curs.length) currencyList.value = curs;
  }

  // overallDaily: array แยก currency → เลือกตามที่เลือกไว้
  const overallRaw = Array.isArray(respData.overallDaily)
    ? pickByCurrency(respData.overallDaily, cur) || {}
    : respData.overallDaily || {};

  // gameDaily: [{ currency, games: [] }] → ดึง games ของ currency ที่เลือก
  let gameList = [];
  if (Array.isArray(respData.gameDaily)) {
    if (respData.gameDaily.length && respData.gameDaily[0]?.games) {
      gameList = pickByCurrency(respData.gameDaily, cur)?.games ?? [];
    } else {
      gameList = respData.gameDaily;
    }
  }

  // by_agent: [{ currency, by_agent: [] }] → ดึง by_agent ของ currency ที่เลือก
  let agentStatsList = [];
  if (Array.isArray(respData.by_agent)) {
    if (respData.by_agent.length && respData.by_agent[0]?.by_agent) {
      agentStatsList = pickByCurrency(respData.by_agent, cur)?.by_agent ?? [];
    } else {
      agentStatsList = respData.by_agent;
    }
  }

  // topPlayerDaily: [{ currency, top_player: {} }] → ดึง top_player ของ currency ที่เลือก
  let topPlayer = null;
  if (Array.isArray(respData.topPlayerDaily)) {
    topPlayer = pickByCurrency(respData.topPlayerDaily, cur)?.top_player ?? null;
  } else {
    topPlayer = respData.topPlayerDaily ?? respData.top_player ?? null;
  }

  return {
    overallDaily: {
      bet_amount: Number(overallRaw.bet_amount || 0),
      win_loss: Number(overallRaw.win_loss || 0),
      buy_feature_amount: Number(overallRaw.buy_feature_amount || 0),
      is_feature_buy: Number(overallRaw.is_feature_buy || 0),
      transaction: Number(overallRaw.transaction || 0),
      player_online: Number(overallRaw.player_online || 0),
      highest_reward: Number(overallRaw.highest_reward || 0),
      bet_amount_highest: Number(overallRaw.bet_amount_highest || 0),
      feature_buy_highest: Number(overallRaw.feature_buy_highest || 0),
    },
    gameDaily: gameList,
    topPlayerDaily: normalizeTopPlayer(topPlayer),
    agents: respData.agents ?? [],
    byAgent: agentStatsList,
  };
}

</script>
<style>
/* ค่าตัวเลขในตารางชิดขวา (override text-align-last: center ของตาราง) */
.table td.text-end {
  text-align: right !important;
  text-align-last: right !important;
}

.pagination {
  margin-top: 10px;
}

.page-numbers {
  display: inline-block;
}

.page-numbers button {
  margin-right: 5px;
}

.page-numbers button.active {
  font-weight: bold;
}
.page-item .page-link {
  color: green;
}
.dark-version h1,
.dark-version .h1,
.dark-version h2,
.dark-version .h2,
.dark-version h3,
.dark-version .h3,
.dark-version h4,
.dark-version .h4,
.dark-version h5,
.dark-version .h5,
.dark-version h6,
.dark-version .h6,
.dark-version
  a:not(.dropdown-item):not(.choices__item):not(.leaflet-control-zoom-in):not(
    .leaflet-control-zoom-out
  ):not(.btn):not(.nav-link):not(.fixed-plugin-button),
.dark-version .table thead tr th,
.dark-version .kanban-title-board {
  color: green;
}
.arrow {
  cursor: pointer;
}

/* ปุ่ม Export สูงเท่า currency tabs */
.export-btn {
  align-self: stretch;
  display: flex;
  align-items: center;
}

/* Currency Tabs */
.currency-tabs {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  background: #f0f2f5;
  border-radius: 12px;
}

.currency-tab {
  border: none;
  background: transparent;
  color: #67748e;
  font-weight: 600;
  font-size: 14px;
  padding: 8px 22px;
  border-radius: 9px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.currency-tab:hover {
  color: #2dce89;
}

.currency-tab.active {
  background: linear-gradient(310deg, #2dce89 0%, #2dcecc 100%);
  color: #fff;
  box-shadow: 0 3px 6px rgba(45, 206, 137, 0.4);
}

@media (max-width: 576px) {
  label {
    font-size: 14px;
  }

  .form-control {
    font-size: 14px;
  }

  .table th,
  .table td {
    font-size: 13px;
    white-space: nowrap;
  }
}
</style>
